import { type Option } from "#/types/options";
import { calculateMaxAvailableSize } from "#/utils/maxAvailableSize.utils";
import { formatValue } from "#/utils/valueFormatters";

export const useValidateOptionLiquidity = ({
  option,
  limitPrice,
  size,
}: {
  option?: Option;
  limitPrice: string;
  size: string;
}) => {
  const { isValid, maxAvailableSize, hasEnoughLiquidity } =
    calculateMaxAvailableSize({
      usersPrice: Number(limitPrice),
      usersSize: Number(size),
      values: option,
    });

  const formattedMaxAvailableSize = formatValue(maxAvailableSize, {
    template: "0.00",
    trailingZeroDisplay: "stripIfInteger",
  });
  const liquidityError =
    isValid && !hasEnoughLiquidity ? (
      <div className="flex gap-1">
        {`${formattedMaxAvailableSize} contracts available at this price.`}
      </div>
    ) : (
      ""
    );
  const liquidityInfo =
    isValid && hasEnoughLiquidity
      ? `Max: ${formattedMaxAvailableSize} contracts available at this price.`
      : "";

  return { liquidityInfo, liquidityError };
};
